
export default {    
    async fetch() {
        await this.$store.dispatch('jsonloader/fetchJson', `vendors.json`)
    },

    beforeRouteLeave(to, from, next) {
        this.$cookies.set('is-vendor-manager-session', false)
        next()
    },
}
